module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAKlBMVEVMaXH////////////////////////////////////////////////////m1kuZAAAADXRSTlMA/FZO+Ufd54arCbCyDliQggAAAHRJREFUeNrl0UEOgzAMRNGxg5NA6/tft0JYSNEwXKB/+5Yfx/wEHmtjOGam+aNumQN7lrOeHHY76dYAv1zo4qTkpLeTki9KTkq+KPmi7FYqvFS7CUW72AF1sFypWbk46P/yF/3lb5ys/+5A9B7q34QuvvP4ATb+CmYo6yZ8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon-close.png
// module id = mLd6
// module chunks = 0